import { useState } from "react";
import OrganizationService from "../services/api/organization";


export const useOrg = () => {

    const [orgList, setOrgList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [orgDetails, setOrgDetails] = useState(null);
    const [orgUserList, setOrgUserList] = useState([]);
    const [isCreating, setIsCreating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [orgVehicleList, setOrgVehicleList] = useState([]);
    const [orgGetpassList, setOrgGatepassList] = useState([]);
    const [orgSubscriptionDetails, setOrgSubscriptionDetail] = useState(null)
    const [filterList, setFilterList] = useState(null);
    const [pagination, setPagination] = useState(0);
    const [loadingOrgUsers, setLoadingOrgUsers] = useState(false);
    const [userListUnfiltered, setUserListUnfiltered] = useState([]);

    const limit = 10;

    const listOrg = (parameters) =>{
        setLoading(true)
        OrganizationService.listOrg(parameters).then((res)=>{
            console.log('listOrg xxxxxxxxxxxxx', res)
            setOrgList(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
        })
    }

    const viewOrg = (org_uid) => {
        setLoading(true)
        OrganizationService.viewOrg(org_uid).then((res)=>{
            console.log('organization data res', res);
            setOrgDetails(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
        })
    }

    const listOrgUsers = (org_id, page, searchFor, searchVal) => {
        setLoadingOrgUsers(true)
        OrganizationService.listOrgUsers(org_id, page, searchFor, searchVal, limit).then((res) => {
            setOrgUserList(res.data.data.flatMap(item => item.users));
            setUserListUnfiltered(res.data.data);
            console.log('listOrgUsers data res', res.data.data);
            setLoadingOrgUsers(false)

            if(res.data.data.length === 0){
                setPagination(0)
            }else{
                var last_page = Math.ceil(res.data.total / limit); //set it depending on ui return - 18
                setPagination(last_page)
            }
        }).catch((err)=>{
            console.log('listOrgUsers errrr', err)
            setLoadingOrgUsers(false)
        })
    }

    const createOrg = (payload) => {
        setIsCreating(true)
        OrganizationService.createOrg(payload).then((res)=>{
            console.log('createOrg data res', res);
            setIsCreating(false)
        }).catch((err)=>{
            console.log('createOrg errrr', err)
            setIsCreating(false)
        })
    }

    const updateOrg = (payload) => {
        setIsUpdating(true)
        OrganizationService.updateOrg(payload).then((res)=>{
            console.log('createOrg data res', res);
            setIsUpdating(false)
        }).catch((err)=>{
            console.log('createOrg errrr', err)
            setIsUpdating(false)
        })
    }

    const listVehicleOrg = (parameters) => {
        setLoading(true)
        OrganizationService.listVehicleOrg(parameters).then((res)=>{
            console.log('listVehicleOrg data res', res);
            setOrgVehicleList(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('listVehicleOrg errrr', err)
            setLoading(false)
        })
    }

    const listOrgGatepass = (parameters) => {
        setLoading(true)
        OrganizationService.listOrgGatepass(parameters).then((res)=>{
            console.log('listOrgGatepass data res', res);
            setOrgGatepassList(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('listOrgGatepass errrr', err)
            setLoading(false)
        })
    }

    const viewOrgSubscription = (org_uid) => {
        setLoading(true)
        OrganizationService.viewOrgSubscription(org_uid).then((res)=>{
            console.log('organization subscription data res', res);
            setOrgSubscriptionDetail(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('errrr', err)
            setLoading(false)
        })
    }

    const filterListOrg = (parameters) =>{
        setLoading(true)
        OrganizationService.filterListOrg(parameters).then((res)=>{
            console.log('filterListOrg xxxxxxxxxxxxx', res)
            setFilterList(res.data.data)
            setLoading(false)
        }).catch((err)=>{
            console.log('filterListOrg errrr', err)
            setLoading(false)
        })
    }

    return{
        listOrg, orgList, loading, viewOrg, orgDetails, listOrgUsers, orgUserList, isCreating, createOrg, updateOrg, isUpdating, listVehicleOrg, orgVehicleList, listOrgGatepass, orgGetpassList, viewOrgSubscription, orgSubscriptionDetails, filterListOrg, filterList, pagination, loadingOrgUsers, userListUnfiltered
    }
}